import FontFamilyTiptap from "@tiptap/extension-font-family";

import { ensureNameValueOptions } from "../../utils/utils";
import { DEFAULT_FONT_FAMILY_LIST } from "../../constants";
import FontFamilyButton from "../../extensions/FontFamily/components/FontFamilyButton";

export const FontFamily = FontFamilyTiptap.extend({
	addOptions() {
		return {
			...this.parent?.(),
			fontFamilyList: DEFAULT_FONT_FAMILY_LIST,
			button({ editor, extension, t }) {
				const { extensions = [] } = editor.extensionManager ?? [];
				const fontFamilyList = ensureNameValueOptions(
					extension?.options?.fontFamilyList || []
				);
				const baseKitExt = extensions.find(k => k.name === "base-kit");

				const items = fontFamilyList.map(font => ({
					action: () => {
						editor.chain().focus().setFontFamily(font.value).run();
					},
					isActive: () =>
						editor.isActive("textStyle", { fontFamily: font.value }) || false,
					title: font.name,
					font: font.value
				}));

				if (baseKitExt && baseKitExt.options.textStyle !== false) {
					items.unshift({
						action: () => editor.chain().focus().unsetFontFamily().run(),
						isActive: () => false,
						disabled: false,
						font: t("editor.fontFamily.default.tooltip"),
						title: "Default Font Style"
					});
				}

				const disabled = items.filter(k => k.disabled).length === items.length;

				return {
					component: FontFamilyButton,
					componentProps: {
						tooltip: t("editor.fontFamily.tooltip"),
						disabled,
						items,
						editor
					}
				};
			}
		};
	}
});
